import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CommonFooter from "../../../components/footer/CommonFooter";
import OrderHeader from "../component/OrderHeader";
import ProductCard from "../component/ProductCard";
import { appApiHandler } from "../../../api/appApiHandler";
import "./OrderDetails.css";
// import HomeHeader from "../../../components/header/HomeHeader";
import InlineLoader from "../../../components/loader/InlineLoader";
import EmptyState from "../../../components/EmptyState";
import { RUPEE } from "../../../constants/globalConstants";
import { useSelector } from "react-redux";
import { FaUser } from "react-icons/fa";
import Breadcrumb from "../../../components/breadcrumb";

const OrderDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isLoggedIn } = useSelector((state) => state.authState);
  const { orderId } = location.state;

  // Check if user came from notification page
  const isFromNotification = location.state?.fromNotification || false;

  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [orderProducts, setOrderProducts] = useState([]);
  const [subTotal, setSubTotal] = useState(0);
  const [taxRate, setTaxRate] = useState(0);
  const [taxAmount, setTaxAmount] = useState(0);

  const getOrderDetails = async () => {
    try {
      const reqData = {
        order_id: orderId,
      };
      const response = await appApiHandler.getOrderDetails(reqData);
      if (response?.status === 200) {
        setOrder(response?.data);
      }
    } catch (error) {
      console.error("Error fetching order details:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (orderId) {
      setLoading(true);
      getOrderDetails();
    }
  }, [orderId]);

  useEffect(() => {
    if (order) {
      setOrderProducts(order?.products || []);
      const subtotal = order?.products?.reduce(
        (sum, p) => sum + p?.price * p?.qty,
        0
      );
      const taxAmount = (subtotal * order?.tax_rate) / 100;
      setSubTotal(subtotal);
      setTaxRate(order?.tax_rate);
      setTaxAmount(taxAmount);
    }
  }, [order]);

  const priceBreakdown = {
    subTotal,
    tax_rate: taxAmount,
    total: order?.total,
  };

  return (
    <div className="order-details-page">
      {/* <HomeHeader /> */}
      <Breadcrumb
        items={[
          {
            label: "Home",
            path: "/",
          },
          ...(isFromNotification
            ? [
                {
                  label: "Notifications",
                  path: "/notifications",
                },
              ]
            : [
                {
                  label: "My Order",
                  path: "/orders",
                },
              ]),
          {
            label: "Order Details",
            isActive: true,
          },
        ]}
      />
      {loading ? (
        <InlineLoader text="Loading order details..." />
      ) : isLoggedIn ? (
        orderId && order ? (
          <div className="order-details-container">
            <OrderHeader order={order} />

            <div className="section-card">
              <h3 className="section-title">Products</h3>
              <div className="products-list">
                {orderProducts.map((product) => (
                  <ProductCard
                    key={product?._id}
                    item={product}
                    order_status={order?.order_status}
                    orderId={orderId}
                    fromNotification={isFromNotification}
                  />
                ))}
              </div>
            </div>

            <div className="section-card">
              {taxAmount > 0 && (
                <>
                  <div className="breakdown-row">
                    <span className="breakdown-label">Sub Total</span>
                    <span className="breakdown-value">
                      {RUPEE}
                      {priceBreakdown.subTotal?.toFixed(2)}
                    </span>
                  </div>
                  <div className="breakdown-row">
                    <span className="breakdown-label">Tax ({taxRate}%)</span>
                    <span className="breakdown-value">
                      {RUPEE}
                      {priceBreakdown.tax_rate?.toFixed(2)}
                    </span>
                  </div>
                </>
              )}
              <div
                className={`breakdown-row breakdown-row--total ${
                  taxAmount <= 0 ? "breakdown-row--total-only" : ""
                }`}
              >
                <span className="breakdown-label breakdown-label--bold">
                  Total
                </span>
                <span className="breakdown-value breakdown-value--bold">
                  {RUPEE}
                  {priceBreakdown.total}
                </span>
              </div>
            </div>

            <div className="section-card">
              <h3 className="section-title">Shipping Address</h3>
              <div className="shipping-address-container">
                <p className="shipping-address-name">{order?.name}</p>
                <p className="shipping-address-phone">
                  {order?.country_code} {order?.contact}
                </p>
                <p className="shipping-address-street">{order?.address}</p>
                <p className="shipping-address-city">{order?.city}</p>
                <p className="shipping-address-location">
                  {order?.state}, {order?.country} - {order?.pincode}
                </p>
              </div>
            </div>
          </div>
        ) : (
          <EmptyState
            title="Order not found"
            description="No order information available. Please select an order from the orders list."
            buttonText="Back to Orders"
            onButtonClick={() => navigate("/orders")}
          />
        )
      ) : (
        <EmptyState
          icon={FaUser}
          title="Sign In to Continue"
          description="please login with your account. Enjoy a seamless shopping experience with personalized recommendations and more!"
          buttonText="Login"
          onButtonClick={() => navigate("/login")}
          iconSize={48}
        />
      )}

      <CommonFooter />
    </div>
  );
};

export default OrderDetails;
